import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  staffs: null,
  loading: false,
  addStaffLoading: false,
  editStaffBtnLoading: false,
  toggleStaffStatusBtnLoading: false,
  deleteStaffBtnLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UTILITY_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
